import { Locale, type LocalizedString } from "../Locale.js";

export const servicesAnchorPathMap = {
	[Locale.cs]: "#sluzby" as const,
} satisfies LocalizedString;
